import { Box, Button, DialogContent, Typography } from "@material-ui/core"
import EditIcon from "@material-ui/icons/Edit"
import GetAppIcon from "@material-ui/icons/GetApp"
import { ReactComponent as ExcelIcon } from "assets/excel-icon.svg"
import AppContext from "contexts/App"
import PropTypes from "prop-types"
import { useCallback, useContext, useState } from "react"

import useStyles from "./styles"

const Upload = ({
  onDrop,
  setFile,
  file,
  setStep,
  step,
  acceptedFiles,
  getRootProps,
  getInputProps,
  fromSuper,
}) => {
  const classes = useStyles()
  const { dialogs, closeDialog, authUser, openSnackBar, token } =
    useContext(AppContext)

  return (
    <>
      <DialogContent>
        {!fromSuper && (
          <>
            <Typography
              color="primary"
              variant="h6"
              className={classes.subtitle}
            >
              Step 1:
            </Typography>
            <Typography variant="subtitle1" className={classes.text}>
              If you would like to import multiple boards and commissions at
              once, please use this provided template to input your data.
            </Typography>
            <Box
              className={classes.downloadContainer}
              display="flex"
              alignItems="center"
              justifyContent="space-between"
              flexWrap="wrap"
            >
              <ExcelIcon />
              <Typography variant="subtitle1" className={classes.fileName}>
                Matchboard_Board_Import_Template.xlsm
              </Typography>
              <Button
                variant="outlined"
                endIcon={<GetAppIcon />}
                onClick={() =>
                  (window.location.href =
                    "/matchboard-board-import-template.xlsm")
                }
              >
                Download
              </Button>
            </Box>
            <Typography
              color="primary"
              variant="h6"
              className={classes.subtitle}
            >
              Step 2:
            </Typography>
          </>
        )}
        <Typography variant="subtitle1" className={classes.text}>
          Upload the completed template here:
        </Typography>
        <Box
          className={classes.uploadContainer}
          display="flex"
          justifyContent="center"
          {...getRootProps()}
        >
          <input {...getInputProps()} />
          {acceptedFiles?.length > 0 ? (
            <Box
              display="flex"
              width="100%"
              justifyContent="center"
              alignItems="center"
              position="relative"
            >
              <EditIcon className={classes.editIcon} />
              <Box marginRight="20px">
                <ExcelIcon />
              </Box>
              <Box>
                <Typography variant="h6" className={classes.resumeName}>
                  {acceptedFiles?.[0]?.name}
                </Typography>
              </Box>
            </Box>
          ) : (
            <>
              <Typography variant="subtitle1">
                <span style={{ fontWeight: "bold" }}>Choose a file</span> or
                drag it here
              </Typography>
            </>
          )}
        </Box>
      </DialogContent>
    </>
  )
}

Upload.propTypes = {
  file: PropTypes.object,
  setFile: PropTypes.func,
  onDrop: PropTypes.func,
  step: PropTypes.object,
  setStep: PropTypes.func,
  getRootProps: PropTypes.func,
  acceptedFiles: PropTypes.array,
  getInputProps: PropTypes.func,
  fromSuper: PropTypes.bool,
}

export default Upload
